<!-- auth-page wrapper -->
<div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
	<div class="bg-overlay"></div>
	<!-- auth-page content -->
	<div class="auth-page-content overflow-hidden pt-lg-5">
		<div class="container">
			<div class="row">
				<div class="col-lg-12">
					<div class="card overflow-hidden m-0">
						<div class="row justify-content-center g-0">
							<div class="col-lg-6">
								<div class="p-lg-5 p-4 auth-one-bg h-100">
									<div class="bg-overlay"></div>
									<div class="position-relative h-100 d-flex flex-column">
										<!-- <div class="mb-4">
                                          <a routerLink="" class="d-block">
                                              <img src="assets/images/logo-light.png" alt="" height="18">
                                          </a>
                                      </div> -->
										<div class="mt-auto">
											<div class="mb-3">
												<i class="ri-double-quotes-l display-4 text-success"></i>
											</div>

											<ngb-carousel [showNavigationArrows]="
													showNavigationArrows
												">
												<ng-template ngbSlide>
													<div class="carousel-inner text-center text-white-50 pb-5">
														<div class="carousel-item active">
															<p class="fs-15 fst-italic">
																" Great! Manage
																your
																appointments
																with your leads!
																"
															</p>
														</div>
													</div>
												</ng-template>
												<ng-template ngbSlide>
													<div class="carousel-inner text-center text-white-50 pb-5">
														<div class="carousel-item active">
															<p class="fs-15 fst-italic">
																" The portal is
																really great
																with an amazing
																customer
																support."
															</p>
														</div>
													</div>
												</ng-template>
												<ng-template ngbSlide>
													<div class="carousel-inner text-center text-white-50 pb-5">
														<div class="carousel-item active">
															<p class="fs-15 fst-italic">
																" Now you can
																see all the
																information of
																the leads. "
															</p>
														</div>
													</div>
												</ng-template>
											</ngb-carousel>
											<!-- end carousel -->
										</div>
									</div>
								</div>
							</div>

							<div class="col-lg-6">
								<div class="p-lg-5 p-4">
									<div class="logo-login">
										<a routerLink="" class="d-block">
											<img src="assets/images/logo_new.png" alt="" />
										</a>
									</div>
									<div>
										<h5 class="text-primary">
											Create Password
										</h5>
										<p class="text-muted">
											Set a password for your account.
										</p>
									</div>

									<div class="mt-4">
										<form [formGroup]="SignupForm" (ngSubmit)="onSubmit()">
											<div class="mb-3">
												<label for="useremail" class="form-label">Email
													<span class="text-danger">*</span></label>
												<input type="email" class="form-control" readonly id="useremail"
													placeholder="Enter email address" required formControlName="email"
													[ngClass]="{
														'is-invalid':
															submitted &&
															f['email'].errors
													}" />
												<div class="invalid-feedback">
													Please enter email
												</div>
											</div>

											<div class="mb-3">
												<label for="userpassword" class="form-label">Password
													<span class="text-danger">*</span></label>
												<div class="position-relative auth-pass-inputgroup">
													<input [type]="
															fieldTextType
																? 'text'
																: 'password'
														" class="form-control pe-5 password-input" placeholder="Enter password" id="password-input"
														aria-describedby="passwordInput"
														pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" required
														formControlName="password" [ngClass]="{
															'is-invalid':
																submitted &&
																f['password']
																	.errors
														}" />
													<button
														class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
														type="button" id="password-addon">
														<i class="ri-eye-fill align-middle" [ngClass]="{
																'mdi-eye-off-outline':
																	!fieldTextType,
																'mdi-eye-outline':
																	fieldTextType
															}" (click)="
																toggleFieldTextType()
															"></i>
													</button>
													<div class="invalid-feedback">
														Please enter password
													</div>
												</div>
												<div class="mb-3">
	<label for="userconfirmpassword" class="form-label">Confirm Password
		<span class="text-danger">*</span></label>
	<div class="position-relative auth-pass-inputgroup">
		<input
			[type]="fieldTextType ? 'text' : 'password'"
			class="form-control pe-5"
			placeholder="Confirm your password"
			id="confirmpassword-input"
			required
			formControlName="confirmPassword"
			[ngClass]="{
				'is-invalid': submitted && (f['confirmPassword'].errors || SignupForm.errors?.['passwordMismatch'])
			}" />
		<div class="invalid-feedback">
			<span *ngIf="f['confirmPassword'].errors?.['required']">Please confirm your password</span>
			<span *ngIf="!f['confirmPassword'].errors?.['required'] && SignupForm.errors?.['passwordMismatch']">Passwords do not match</span>
		</div>
	</div>
</div>
											</div>

											<!-- <div class="mb-4">
												<p class="mb-0 fs-12 text-muted fst-italic">
													By registering you agree to
													the Velzon
													<a href="javascript:void(0);"
														class="text-primary text-decoration-underline fst-normal fw-medium">Terms
														of Use</a>
												</p>
											</div> -->

											<div id="password-contain" class="p-3 bg-light mb-2 rounded">
												<h5 class="fs-13">
													Password must contain:
												</h5>
												<p id="pass-length" class="invalid fs-12 mb-2">
													Minimum <b>8 characters</b>
												</p>
												<p id="pass-lower" class="invalid fs-12 mb-2">
													At <b>lowercase</b> letter
													(a-z)
												</p>
												<p id="pass-upper" class="invalid fs-12 mb-2">
													At least
													<b>uppercase</b> letter
													(A-Z)
												</p>
												<p id="pass-number" class="invalid fs-12 mb-0">
													A least <b>number</b> (0-9)
												</p>
											</div>

											<div class="mt-4">
												<button
													type="submit"
													class="btn btn-success w-100"
													[ngClass]="{ 'btn-load': loading }"
													[disabled]="loading">
													<span class="d-flex align-items-center" *ngIf="loading">
														<span class="flex-grow-1 me-2">
															Loading...
														</span>
														<span class="spinner-border flex-shrink-0" role="status">
															<span class="visually-hidden">Loading...</span>
														</span>
													</span>
													<span *ngIf="!loading">Sign Up</span>
												</button>


												<!-- <button class="btn btn-success w-100" type="submit">
													Sign up
												</button> -->
											</div>

											<!-- <div class="mt-4 text-center">
                                              <div class="signin-other-title">
                                                  <h5 class="fs-13 mb-4 title text-muted">Create account with</h5>
                                              </div>

                                              <div class="d-flex gap-2 justify-content-center">
                                                  <button type="button" class="btn btn-primary btn-icon waves-effect waves-light"><i class="ri-facebook-fill fs-16"></i></button>
                                                  <button type="button" class="btn btn-danger btn-icon waves-effect waves-light"><i class="ri-google-fill fs-16"></i></button>
                                                  <button type="button" class="btn btn-dark btn-icon waves-effect waves-light"><i class="ri-github-fill fs-16"></i></button>
                                                  <button type="button" class="btn btn-info btn-icon waves-effect waves-light"><i class="ri-twitter-fill fs-16"></i></button>
                                              </div>
                                          </div> -->
										</form>
									</div>

									<div class="mt-5 text-center">
										<p class="mb-0">
											Already have an account ?
											<a routerLink="/auth/signin/cover"
												class="fw-semibold text-primary text-decoration-underline">
												Signin</a>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- end card -->
				</div>
				<!-- end col -->
			</div>
			<!-- end row -->
		</div>
		<!-- end container -->
	</div>
	<!-- end auth page content -->

	<!-- footer -->
	<footer class="footer">
		<div class="container">
			<div class="row">
				<div class="col-lg-12">
					<div class="text-center">
						<p class="mb-0">
							&copy; {{ year }} LMS leads.
							<i class="mdi mdi-heart text-danger"></i>
						</p>
					</div>
				</div>
			</div>
		</div>
	</footer>
	<!-- end Footer -->
</div>
<!-- end auth-page-wrapper -->
